<div
  class="app-admin-wrap example-boundary"
  [dir]="layoutConf?.dir"
  style="position: relative"
>
  <div style="position: absolute; width: 100%; height: 100%">
    <app-process-template
      cdkDragBoundary=".example-boundary"
      cdkDrag
      [cdkDragFreeDragPosition]="dragPosition"
      style="z-index: 1000; position: absolute"
    >
    </app-process-template>
  </div>

  <!-- Header for top navigation layout -->
  <!-- ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT -->
  <app-header-top
    *ngIf="layoutConf.navigationPos === 'top'"
    [notificPanel]="notificationPanel"
  >
  </app-header-top>

  <!-- Main Container -->
  <mat-sidenav-container
    style="background-color: #f5f5fd;"
    [dir]="layoutConf.dir"
    class="app-admin-container app-side-nav-container mat-drawer-transition sidebar-{{layoutConf?.sidebarColor}} topbar-{{layoutConf?.topbarColor}} footer-{{layoutConf?.footerColor}}"
    [ngClass]="adminContainerClasses"
  >
    <mat-sidenav-content>
      <!-- SIDEBAR -->
      <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
      <app-sidebar-side
        *ngIf="layoutConf.navigationPos === 'side'"
      ></app-sidebar-side>

      <!-- Top navigation layout (navigation for mobile screen) -->
      <!-- ONLY REQUIRED FOR **TOP** NAVIGATION MOBILE LAYOUT -->
      <app-sidebar-top
        *ngIf="layoutConf.navigationPos === 'top' && layoutConf.isMobile"
      ></app-sidebar-top>
      <ngx-ui-loader
        [loaderId]="'loader02'"
        [fgsColor]="'#fd9b14'"
        [bgsColor]="'#10b7cb'"
        [bgsPosition]="'bottom-right'"
        [bgsType]="'ball-spin-clockwise'"
        [fgsPosition]="'center-center'"
        [fgsType]="'ball-spin-clockwise'"
        [logoPosition]="'center-center'"
        [overlayColor]="'rgba(40, 40, 40, 0.4)'"
        [pbColor]="'#fd9b14'"
        [pbDirection]="'ltr'"
        [textColor]="'#FFFFFF'"
        [textPosition]="'center-center'"
      ></ngx-ui-loader>
      <!-- App content -->
      <div
        class="main-content-wrap"
        id="main-content-wrap"
        [perfectScrollbar]=""
        [disabled]="layoutConf.topbarFixed || !layoutConf.perfectScrollbar"
      >
        <!-- Header for side navigation layout -->
        <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
        <app-header-side
          *ngIf="layoutConf.navigationPos === 'side'"
          [notificPanel]="notificationPanel"
        >
        </app-header-side>

        <div
          class="rightside-content-hold"
          id="rightside-content-hold"
          [perfectScrollbar]="scrollConfig"
          [disabled]="!layoutConf.topbarFixed || !layoutConf.perfectScrollbar"
        >
          <!-- View Loader -->
          <div
            class="view-loader"
            *ngIf="isModuleLoading"
            style="position: fixed; z-index: 99"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="spinner">
              <div class="double-bounce1 mat-bg-accent"></div>
              <div class="double-bounce2 mat-bg-primary"></div>
            </div>
          </div>
          <!-- Breadcrumb -->
          <!-- <app-breadcrumb></app-breadcrumb> -->
          <!-- View outlet -->
          <!-- <div class="container-dynamic"> -->

          <router-outlet></router-outlet>
          <!-- </div> -->
          <span class="m-auto" *ngIf="!layoutConf.footerFixed"></span>
          <!-- <app-footer
            *ngIf="!layoutConf.footerFixed"
            style="margin: 0 -0.33rem -0.33rem"
          ></app-footer> -->
        </div>
        <span class="m-auto" *ngIf="layoutConf.footerFixed"></span>
        <app-footer *ngIf="layoutConf.footerFixed"></app-footer>
      </div>
      <!-- View overlay for mobile navigation -->
      <div
        class="sidebar-backdrop"
        [ngClass]="{'visible': layoutConf.sidebarStyle !== 'closed' && layoutConf.isMobile}"
        (click)="closeSidebar()"
      ></div>
    </mat-sidenav-content>

    <!-- Notificaation bar -->
    <mat-sidenav #notificationPanel mode="over" class="" position="end">
      <div class="nofication-panel" fxLayout="column" style="height: 100%">
        <app-notifications
          style="display: flex; flex-direction: column; height: 100%"
          [notificPanel]="notificationPanel"
        ></app-notifications>
      </div>
    </mat-sidenav>

    <egret-notifications2></egret-notifications2>
  </mat-sidenav-container>
</div>

<!-- Only for demo purpose -->
<!-- Remove this from your production version -->
<!-- <app-customizer></app-customizer> -->

<div id="main-progress-bar" style="display: none;
padding: 10px;
background: #ff8a48;
position: fixed;
bottom: 0px;
right: 0px;
z-index: 1502;
font-size: 14px;
color: white;">

</div>